import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetAllLifeAndMemories } from 'typings/api.typings';
import { appInitialState } from './app.constants';
import { IActiveFolder, TSelectedView } from './app.typings';

export const appSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    setView: (state, action: PayloadAction<TSelectedView>) => {
      state.selectedView = action.payload;
    },
    setMemoryIdScroll: (state, action: PayloadAction<string>) => {
      state.memoryIdScroll = action.payload;
    },
    setActiveFolder: (state, action: PayloadAction<IActiveFolder>) => {
      state.activeFolder = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setAllLifeScriptsAndMemories: (state, action: PayloadAction<IGetAllLifeAndMemories[]>) => {
      state.allLifeScriptsAndMemories = action.payload;
    },
    clearApp: () => {
      localStorage.clear();
      sessionStorage.clear();
      return appInitialState;
    },
  },
});
const { actions, reducer } = appSlice;
export const { setView, setMemoryIdScroll, setActiveFolder, setSearchTerm, setAllLifeScriptsAndMemories, clearApp } =
  actions;
export { reducer as appReducer };
